"use client";
import { isFunction } from 'lodash';
import { useCallback } from 'react';
import { yupResolver as o } from './dist.js';
import { zodResolver as t } from './dist2.js';

const useValidationResolver = (options, locale, translate) => {
    const { validation, validationMode } = options;
    const resolver = useCallback(async (...params) => {
        const values = params[0];
        if (!validation)
            return { values, errors: {} };
        if (validationMode === 'zod') {
            const validationSchema = isFunction(validation) ? validation(values) : validation;
            return t(validationSchema)(...params);
        }
        else {
            const validationSchema = isFunction(validation) ? validation(values) : validation;
            return o(validationSchema)(...params);
        }
    }, [validation, locale, translate]);
    return resolver;
};

export { useValidationResolver as default };
